import { render, staticRenderFns } from "./success.html?vue&type=template&id=55819685&scoped=true&"
import script from "./success.vue?vue&type=script&lang=ts&"
export * from "./success.vue?vue&type=script&lang=ts&"
import style0 from "./success.scss?vue&type=style&index=0&id=55819685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55819685",
  null
  
)

export default component.exports